import React, { useState } from "react";

import caretLeft from "../../../assets/images/angle-left-solid.svg";

import { keylessColors } from "../utils";

import { KeylessModal } from "./KeylessModal";
import { KeylessButton } from "./KeylessButton";

export const KEYLESS_STEPS = {
  LOCATION: 0,
  SIGNATURE: 1,
  VEHICLE: 2,
  DOOR: 3,
};

export function KeylessPageLayout({
  children,
  step,
  localizationAssets,
  reservationNumber,
  t = () => {
    return "";
  },
  handleBack,
  footer,
}) {
  const [helpModalOpen, setHelpModalOpen] = useState(false);

  const handleHelpClick = () => {
    setHelpModalOpen(true);
  };

  return (
    <div style={styles.page}>
      <PageHeader currentStep={step} localizationAssets={localizationAssets} />
      <div className="container" style={styles.reservationLine}>
        <div style={{ opacity: reservationNumber ? 1 : 0 }}>
          {t("keylessReservationNumber")} {reservationNumber}
        </div>
        <div style={styles.reservationLineHelp} onClick={handleHelpClick}>
          <div>{t("keylessReservationHelp")}</div>
          <img
            src={localizationAssets["keylessReservationHelp"]}
            style={styles.reservationLineHelpImg}
            alt=""
          />
        </div>
      </div>
      {handleBack ? (
        <div className="container mt-2">
          <img
            onClick={handleBack}
            style={styles.backArrow}
            src={caretLeft}
            alt=""
          />{" "}
        </div>
      ) : null}
      <div style={styles.spacer} />
      <div style={styles.children}>{children}</div>
      <div style={styles.footer}>
        {footer}
      </div>
      <KeylessModal
        isOpen={helpModalOpen}
        title={t('keylessHelpTitle')}
        message={t('keylessHelpMessage')}
        animation="slide-up"
        img={localizationAssets["keylessReservationHelp"]}
        imgStyle={{ height: '35px', width: '35px' }}
        modalStyle={{ minHeight: '350px' }}
        actions={
          <KeylessButton
            text={t("keylessHelpClose")}
            onClick={() => setHelpModalOpen(false)}
          />
        }
      />
    </div>
  );
}

function PageHeader({ currentStep, localizationAssets }) {
  const items = [
    {
      step: KEYLESS_STEPS.LOCATION,
      img:
        currentStep <= KEYLESS_STEPS.LOCATION
          ? "keylessPinIconWhite"
          : "keylessPinIconGreen",
    },
    {
      step: KEYLESS_STEPS.VEHICLE,
      img:
        currentStep <= KEYLESS_STEPS.VEHICLE
          ? "keylessCarIconWhite"
          : "keylessCarIconGreen",
    },
    {
      step: KEYLESS_STEPS.DOOR,
      img:
        currentStep <= KEYLESS_STEPS.DOOR
          ? "keylessLockIconWhite"
          : "keylessLockIconGreen",
    },
  ];

  return (
    <div style={styles.header} className="container">
      <img
        src={localizationAssets["keylessGuerinLogo"]}
        alt="Guerin"
        style={styles.logo}
        height="60px"
        width="80px"
      />
      <div style={styles.breadcrumbs}>
        {items.map((item, index) => (
          <>
            <div
              style={
                currentStep > item.step
                  ? styles.breadcrumbItemActive
                  : styles.breadcrumbItem
              }
            >
              <img
                width="30px"
                style={styles.breadcrumbItemImg}
                src={localizationAssets[item.img]}
              />
            </div>
            {index === items.length - 1 ? null : (
              <div
                style={
                  currentStep > item.step
                    ? styles.breadcrumbLineActive
                    : styles.breadcrumbLine
                }
              />
            )}
          </>
        ))}
      </div>
    </div>
  );
}

const styles = {
  page: {
    height: "100dvh",
    display: "flex",
    flexDirection: "column",
    fontFamily: "'BlissLight'",
  },
  children: {
    flex: "1",
  },
  footer: {
    backgroundColor: '#F5F5F5',
    height: '12vh',
    display: 'flex',
    alignItems: 'center',
    padding: '0 15px',
  },
  backArrow: {
    height: "20px",
  },
  spacer: {
    width: "100%",
    marginBottom: "2rem",
  },
  header: {
    backgroundColor: keylessColors.green,
    display: "flex",
    alignItems: "center",
    paddingTop: "20px",
    paddingBottom: "20px",
    gap: "2rem",
  },
  breadcrumbs: {
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  breadcrumbItemActive: {
    backgroundColor: "white",
    borderRadius: "50%",
    height: "50px",
    width: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  breadcrumbItem: {
    backgroundColor: "rgba(0,0,0,.4)",
    borderRadius: "50%",
    height: "50px",
    width: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  breadcrumbItemImg: {
    height: "60%",
  },
  breadcrumbLine: {
    backgroundColor: "rgba(0,0,0,.4)",
    height: "10px",
    width: "16%",
    flex: "1",
  },
  breadcrumbLineActive: {
    backgroundColor: "white",
    height: "10px",
    width: "100%",
    flex: "1",
  },
  logo: {
    width: "80px",
  },

  reservationLine: {
    backgroundColor: "#F0F0F0",
    paddingTop: "5px",
    paddingBottom: "5px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  reservationLineHelp: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    color: "#FD812A",
  },
  reservationLineHelpImg: {
    height: "25px",
  },
};
